<a
  class='!tw-text-lendio-blue-500'
  href="javascript:"
  (click)="openDialog()">
  View borrower’s feedback
</a>
